import { render } from "./CertificateQuery.vue?vue&type=template&id=433197ac&scoped=true"
import script from "./CertificateQuery.vue?vue&type=script&lang=js"
export * from "./CertificateQuery.vue?vue&type=script&lang=js"

import "./CertificateQuery.vue?vue&type=style&index=0&id=433197ac&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433197ac"]])

export default __exports__